module.exports = __webpack_public_path__ + "static/media/flight_nav.e6523073.svg";